import ReactDOM from 'react-dom';
import 'jqwidgets-scripts/jqwidgets/styles/jqx.base.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { HashRouter as Router } from 'react-router-dom';
import './styles/styles.scss';
import App from './App';
import { registerLicense } from '@syncfusion/ej2-base';
import { Language } from './language';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWX1fcXVWRGJYVEdzXEo=');

const theme = createTheme();

ReactDOM.render(
  <Router>
    <ThemeProvider theme={theme}>
    <DndProvider backend={HTML5Backend} {...({} as any)}>
      <App />
    </DndProvider>
    </ThemeProvider>
  </Router>,
  document.getElementById('root')
);
